/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */

(function ($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// Home page
		'home': {
			init: function () {
				// JavaScript to be fired on the home page

				if((typeof googleMapsInitialize) !== "undefined"){
					google.maps.event.addDomListener(window, "load", googleMapsInitialize);
				}

			}
		},
		// Pricing page
		'page_template_page_event_pricing': {
			init: function () {
				// JavaScript to be fired on the pricing page

				$(".event-ticket-pricing-table select").on("change", function() {

					if ($(this).parents('tbody').children().length === 1) {

						var conferenceQty = parseInt($(this).val());

					} else if ($(this).parents('tbody').children().length === 2) {

						var conferenceQty = parseInt($(this).parents('tbody').find('tr:first-child select').val()) + parseInt($(this).parents('tbody').find('tr:last-child select').val());

					}

					if (conferenceQty !== 0) {

						$(".event-workshop-pricing-table select").each(function() {

							var addonQty = parseInt($(this).val());

							$(this).children(":not(:first-child)").remove();

							for (i = 1; i <= conferenceQty; i++) {

								$(this).append("<option value=\"" + i + "\">" + i + "</option>");

							}

							if (addonQty > conferenceQty) {
								addonQty = conferenceQty;
							}

							$(this).val(addonQty);

							$(this).prop("disabled", false);

						});

					} else {

						$(".event-workshop-pricing-table select").prop("disabled", true).children(":not(:first-child)").remove();

					}

				});

			}
		},
		// Venue page
		'page_event_venue': {
			init: function () {
				// JavaScript to be fired on the venue page

				if((typeof googleMapsInitialize) !== "undefined"){
					google.maps.event.addDomListener(window, "load", googleMapsInitialize);
				}

			}
		},
		// Agenda page
		'page_event_agenda': {
			init: function () {
				// JavaScript to be fired on the agenda page

				$('.agenda-tab a[data-toggle]').on("click", function(){

					$(".agenda-tab.active").removeClass("active")

					$(this).parents(".agenda-tab").toggleClass("active");

				});

				// Keep carousel from transitioning other than on click
				$('.agenda-table-session-carousel .carousel').carousel({
					pause: true,
					interval: false
				});

				$(".agenda-table-session-carousel").on("slide.bs.carousel", function(evt){

					var carouselData = $(this).find(".carousel").data("bs.carousel");

					var currSlideNum = carouselData.getItemIndex($(this).find(evt.relatedTarget));

					$(this).find(".carousel-indicators .btn")
						.removeClass("active")
						.filter('[data-slide-to="' + currSlideNum + '"]')
							.addClass("active");

				});

			}
		},
		// Sponsor Pricing page
		'page_template_page_event_pricing_sponsor': {
			init: function () {
				// JavaScript to be fired on the sponsor pricing page

				aallSpexRegPageScript();

				window.aallSpexReg = {
					emailMatch: false,
					passesExceeded: false,
					exboPassesExceeded: false
				};

				$('.sponsor-info-wrap').on('input propertychange paste', '#sponsor-email-input, #confirm-sponsor-email-input', function() {

					if($('#sponsor-email-input').val() === $('#confirm-sponsor-email-input').val() && $('#sponsor-email-input').val() !== ""){

						aallSpexReg.emailMatch = true;

						$('#match-status').addClass('match').text('Confirmed!');

					} else {

						aallSpexReg.emailMatch = false;

						$('#match-status').removeClass('match').text('This email address must match the \'Primary Contact Email Address\' entered to continue.');

					}

				});

				$(".event-ticket-pricing-table tbody tr:first-child select").on("change", function() {

					var passesSelected = 0;

					$(".event-ticket-pricing-table tbody tr:first-child select").each(function(){
						passesSelected = passesSelected + parseInt($(this).val());
					});

					if(passesSelected > aallSpexRegPassesAvailable){

						aallSpexReg.passesExceeded = true;

						if(!$(".event-ticket-pricing-table tbody tr:first-child .passes-exceeded-msg").length){
							$(".event-ticket-pricing-table tbody tr:first-child select").each(function(){
								$('<span class="passes-exceeded-msg">Total Exceeded</span>').insertAfter($(this));
							});
						}

					}else{

						aallSpexReg.passesExceeded = false;

						$(".event-ticket-pricing-table tbody tr:first-child .passes-exceeded-msg").remove();

					}

				});

				$(".event-ticket-pricing-table tbody tr:last-child select").on("change", function() {

					var exboPassesSelected = 0;

					$(".event-ticket-pricing-table tbody tr:last-child select").each(function(){
						exboPassesSelected = exboPassesSelected + parseInt($(this).val());
					});

					if(exboPassesSelected > aallSpexRegExboPassesAvailable){

						aallSpexReg.exboPassesExceeded = true;

						if(!$(".event-ticket-pricing-table tbody tr:last-child .passes-exceeded-msg").length){
							$(".event-ticket-pricing-table tbody tr:last-child select").each(function(){
								$('<span class="passes-exceeded-msg">Total Exceeded</span>').insertAfter($(this));
							});
						}

					}else{

						aallSpexReg.exboPassesExceeded = false;

						$(".event-ticket-pricing-table tbody tr:last-child .passes-exceeded-msg").remove();

					}

				});

				$(".event-pricing-table-submit button").on("mouseenter", function(){

					if (!aallSpexReg.emailMatch || aallSpexReg.passesExceeded || aallSpexReg.exboPassesExceeded) {

						if (!aallSpexReg.emailMatch) {

							$('#match-status').removeClass('match').text('This email address must match the \'Primary Contact Email Address\' entered to continue.');

						}

						if (aallSpexReg.passesExceeded) {

							if(!$(".event-ticket-pricing-table tbody tr:first-child .passes-exceeded-msg").length){
								$(".event-ticket-pricing-table tbody tr:first-child select").each(function(){
									$('<span class="passes-exceeded-msg">Total Exceeded</span>').insertAfter($(this));
								});
							}

						}

						if (aallSpexReg.exboPassesExceeded) {

							if(!$(".event-ticket-pricing-table tbody tr:last-child .passes-exceeded-msg").length){
								$(".event-ticket-pricing-table tbody tr:last-child select").each(function(){
									$('<span class="passes-exceeded-msg">Total Exceeded</span>').insertAfter($(this));
								});
							}

						}

						scrollTo(0,0);

					}

				});

				$(".event-workshop-pricing-table select").each(function(){
					$(this).attr('disabled', true);
				});

				$("#add-to-cart-form > div:nth-of-type(2) .event-ticket-pricing-table tbody tr:not(:last-child) select").on("change", function() {

					var conferenceQty = parseInt($(this).parents('tbody').find('tr:first-child select').val()) + parseInt($(this).parents('tbody').find('tr:nth-child(2) select').val());

					if (conferenceQty !== 0) {

						$("#add-to-cart-form > div:nth-of-type(3) .event-workshop-pricing-table select").each(function() {

							var addonQty = parseInt($(this).val());

							$(this).children(":not(:first-child)").remove();

							for (i = 1; i <= conferenceQty; i++) {

								$(this).append("<option value=\"" + i + "\">" + i + "</option>");

							}

							if (addonQty > conferenceQty) {
								addonQty = conferenceQty;
							}

							$(this).val(addonQty);

							$(this).prop("disabled", false);

						});

					} else {

						$("#add-to-cart-form > div:nth-of-type(3) .event-workshop-pricing-table select").prop("disabled", true).children(":not(:first-child)").remove();

					}

				});

				$("#add-to-cart-form > div:nth-of-type(4) .event-ticket-pricing-table tbody tr:not(:last-child) select").on("change", function() {

					var conferenceQty = parseInt($(this).parents('tbody').find('tr:first-child select').val()) + parseInt($(this).parents('tbody').find('tr:nth-child(2) select').val());

					if (conferenceQty !== 0) {

						$("#add-to-cart-form > div:nth-of-type(5) .event-workshop-pricing-table select").each(function() {

							var addonQty = parseInt($(this).val());

							$(this).children(":not(:first-child)").remove();

							for (i = 1; i <= conferenceQty; i++) {

								$(this).append("<option value=\"" + i + "\">" + i + "</option>");

							}

							if (addonQty > conferenceQty) {
								addonQty = conferenceQty;
							}

							$(this).val(addonQty);

							$(this).prop("disabled", false);

						});

					} else {

						$("#add-to-cart-form > div:nth-of-type(5) .event-workshop-pricing-table select").prop("disabled", true).children(":not(:first-child)").remove();

					}

				});

			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function (func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function () {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
